module.exports = __webpack_public_path__ + "static/media/arrow-down-green.b9217211.svg";